import React from 'react';

const ConfirmModalPost = ({ show, onConfirm, onCancel }) => {
  if (!show) {
    return null; 
  }

  return (
    <div className="confirm-modal-overlay">
      <div className="confirm-modal">
        <h4>Confirm Deletion</h4>
        <p>Are you sure you want to delete this post?</p>
        <div className="confirm-modal-buttons">
          <button onClick={onConfirm} className="btn btn-danger delete_user_btn">
            Yes, Delete
          </button>
          <button onClick={onCancel} className="btn btn-secondary send_btn">
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModalPost;
